import type { LC_TimezoneItem, Timezone } from './timezones.types';


export function mapTimezoneOutToModel(item: LC_TimezoneItem): Timezone {
  return {
    id: item.timezoneId,
    description: item.description,
  };
}
